<template>
  <admin-layout title="Criando sala de reunião" menu="Live">
    <div class="row">
      <div class="col-lg-9 col-xs-12">
        <div class="row">
          <div class="col-lg-12 col-xs-12">
            <span class="ml-3 f14 font-weight-bold">TÍTULO</span>
            <inputform
              v-model="rooms.title"
              type="text"
              :field="$v.rooms.title"
              class="label-bold mt-2"
            />
          </div>
          <div class="col-lg-4 col-xs-12">
            <span class="ml-3 f14 font-weight-bold">DIA DA REUNIÃO</span>
            <Datepicker
              type="datetime"
              v-model="date_current"
              input-class="form-control mt-2"
              :language="ptBR"
            ></Datepicker>
          </div>
          <div class="col-lg-4 col-xs-12">
            <span class="ml-3 f14 font-weight-bold">HORÁRIO DE INÍCIO</span>
            <input
              class="form-control mt-2"
              v-model="start_hour"
              v-mask="['##:##']"
              @blur="autoCompleteStartHour()"
            />
          </div>
          <div class="col-lg-4 col-xs-12">
            <span class="ml-3 f14 font-weight-bold">HORÁRIO DE TÉRMINO</span>
            <input
              class="form-control mt-2"
              v-model="end_hour"
              v-mask="['##:##']"
              @blur="autoCompleteEndHour()"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-5 mt-4 col-xs-12 overflow-hidden">
        <div class="row">
          <div class="col-lg-12 formJov p-2">
            <div class="row">
              <div class="col-lg-12">
                <button
                  :disabled="load"
                  @click="save"
                  type="buttom"
                  class="btn full btn-primary f13 p-2 radius-0"
                >
                  SALVAR
                </button>
              </div>
              <div v-if="rooms.link" class="col-lg-12 col-xs-12 mt-3 mb-3">
                <input
                  type="text"
                  id="linkShare"
                  class="form-control"
                  v-model="rooms.link"
                  readonly="true"
                />
              </div>
              <div v-if="rooms.link" class="col-lg-12 col-xs-12">
                <button
                  v-clipboard:copy="rooms.link"
                  v-clipboard:success="onCopy"
                  class="btn full btn-primary f13 radius-0"
                >
                  COPIAR LINK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import moment from "moment";
import { Datetime } from "vue-datetime";
import { required, minLength } from "vuelidate/lib/validators";
import { ptBR } from "vuejs-datepicker/dist/locale";
import { mask } from "vue-the-mask";
import Datepicker from "vuejs-datepicker";
export default {
  props: ["room", "link"],
  components: { Datetime, Datepicker },
  data: () => ({
    load: false,
    ptBR: ptBR,
    date_current: moment().format(),
    start_hour: moment().format("HH:mm"),
    end_hour: moment().add(30, "minutes").format("HH:mm"),
    rooms: {
      id: 0,
      title: "",
      link: "",
      start_date: moment().format(),
      end_date: moment().format(),
    },
  }),
  methods: {
    autoCompleteStartHour() {
      if (this.start_hour.length <= 4) {
        for (let sizeHour = this.start_hour.length; sizeHour <= 4; sizeHour++) {
          this.start_hour = this.start_hour + "0";
        }
      }
    },
    autoCompleteEndHour() {
      if (this.end_hour.length <= 4) {
        for (let sizeHour = this.end_hour.length; sizeHour <= 4; sizeHour++) {
          this.end_hour = this.end_hour + "0";
        }
      }
    },
    validDates() {
      let start = moment(this.rooms.start_date),
        end = moment(this.rooms.end_date);

      if (start.diff(end, "minutes") > 0) return 0;
      if (start.diff(end, "minutes") < -1445) return 1;
      return false;
    },
    onCopy: function (e) {
      this.$toast.success("LINK COPIADO COM SUCESSO");
    },
    save() {
      this.$v.rooms.$touch();
      if (this.$v.rooms.$invalid) {
        this.$toast.error("PREENCHA O NOME DA SALA");
        return;
      }
      let date_error = this.validDates();

      if (date_error !== false) {
        if (date_error === 0)
          this.$toast.error(
            "A data final não pode ser inferior a data inicial"
          );
        else
          this.$toast.error(
            "SINTO MUITO, MAS A SALA NÃO PODE TER UMA DURAÇÃO MAIOR QUE 24 HORAS"
          );
        return;
      }

      let url = "/recruiters/rooms";
      if (this.rooms.id != 0) {
        url = `/recruiters/rooms/${this.rooms.id}`;
      }

      this.load = true;
      axios
        .post(url, {
          rooms: {
            title: this.rooms.title,
            start_date: `${moment(this.date_current).format("YYYY-MM-DD")} ${
              this.start_hour
            }`,
            end_date: `${moment(this.date_current).format("YYYY-MM-DD")} ${
              this.end_hour
            }`,
          },
        })
        .then((response) => {
          this.$toast.success("SALA SALVA COM SUCESSO");
          this.rooms.link = response.data.link;
          this.rooms.id = response.data.room.id;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
        });
    },
  },
  mounted() {
    this.rooms = {
      id: this.room.id ? this.room.id : 0,
      title: this.room.title,
      start_date: this.room.start_date
        ? this.room.start_date
        : moment().format(),
      end_date: this.room.end_date
        ? this.room.end_date
        : moment().add(40, "minutes").format(),
      link: this.link,
    };
    this.date_current = this.rooms.start_date;
  },
  validations: {
    rooms: {
      title: { required, minLength: minLength(4) },
      start_date: { required },
      end_date: { required },
    },
  },
};
</script>

<style>
</style>